export const EPSG4490 = {
  name: "EPSG:4490",
  proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
  wkt: 'GCS_China_Geodetic_Coordinate_System_2000',
}